import React, { useEffect, useState } from 'react'
import '../styles/ScreenEventPlaylistModule.css'
import { Row, Col, Popover, Badge } from 'antd'
import ScreenEventPlaylistModuleItem from './ScreenEventPlaylistModuleItem';
import { PlusCircleFilled } from '@ant-design/icons'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';
import PopupManager from '../managers/PopupManager';

function ScreenEventPlaylistModule(props) {

    const [screenEPlaylists, setScreenEPlaylists] = useState([]);
    const { data, eventTypesData, onSave = () => { }, screenData, onDataUpdated = () => { } } = props;

    var defaultData = {
        TimelineScheduleID: -1,
        TimelineID: -1,
        WeekDay: "0,1,2,3,4,5,6",
        StartTime: "",
        EndTime: "",
        StartDate: "",
        EndDate: ""
    }

    const launchCreateScreenEventPlaylistPopup = (screenEventPlDat) => {

        console.log("launchCreateScreenEventPlaylistPopup")
        console.log("screenData " + JSON.stringify(screenData))
        console.log("eventTypesData " + JSON.stringify(eventTypesData))
        PopupManager.launchCreateScreenEventPlaylistPopup(() => {
            console.log("create_screeneventplaylist success ")
            reloadTimelineSchedules();
            // onSaved();
        }, screenData, eventTypesData)
    }
    const createScreenEventPlaylist = (screenEventsData) => {
        // const { requestServerPost, usertoken } = props;


        // const params = new FormData();
        // const { TimelineScheduleID, TimelineID } = data;
        // const { WeekDay, StartTime, EndTime, StartDate, EndDate } = screenEventsData;

        // params.append("timelinescheduleid", TimelineScheduleID)
        // params.append("timelineid", TimelineID)
        // params.append("weekday", WeekDay)
        // params.append("starttime", StartTime)
        // params.append("endtime", EndTime)
        // params.append("startdate", StartDate)
        // params.append("enddate", EndDate)


        // requestServerPost("create_timelineschedule", params, {}, (response) => {
        //     reloadTimelineSchedules();
        // }, usertoken);
    }
    const deleteScreenEventPlaylist = (screenEventsData, callback = () => { }) => {
        const { requestServerPost, usertoken } = props;
        const params = new FormData();
        const { ScreenEventPlaylistID } = screenEventsData;

        params.append("screeneventplaylistid", ScreenEventPlaylistID)

        requestServerPost("delete_screeneventplaylist", params, {}, (response) => {
            console.log("delete_screeneventplaylist success ")
            // onSaved();
            callback();
            reloadTimelineSchedules();
        }, usertoken);
    }

    const reloadTimelineSchedules = () => {
        const { requestServerGet, usertoken, selectedBrandData, selectedBranchData } = props;

        const { ScreenID } = screenData;

        requestServerGet("get_screeneventplaylists", { brandid: selectedBrandData.BrandID, branchid: selectedBranchData.BranchID }, {}, (response) => {
            const filteredData = response.data.filter(d => {
                return d.ScreenID === screenData.ScreenID;
            })

            console.log("GOT net event datas  " + JSON.stringify(filteredData))
            setScreenEPlaylists(filteredData)
            onDataUpdated(response.data);
        }, usertoken);
    }

    useEffect(() => {
        setScreenEPlaylists(data)
    }, [])

    useEffect(() => {
        // console.log(JSON.stringify(screenEPlaylists))
    }, [screenEPlaylists])

    return (
        <div className="scheduler">
            <div className="itemgroup">
                <div>
                    {screenEPlaylists.sort((a, b) => {
                        return b.Priority - a.Priority;
                    }).map((screenEPlaylistDat, index) => (
                        <ScreenEventPlaylistModuleItem key={`event_${screenData.ScreenID}_${screenEPlaylistDat.ScreenEventPlaylistID}_${index}`} screenData={screenData} eventTypesData={eventTypesData} data={screenEPlaylistDat} onSave={(params) => {
                            console.log("update complete")
                            reloadTimelineSchedules();
                            onSave()
                        }} onRemove={(e) => {
                            console.log("Click delete screen event playlist")
                            deleteScreenEventPlaylist(screenEPlaylistDat)
                            e.preventDefault();
                        }
                        }></ScreenEventPlaylistModuleItem>
                    ))}
                </div>
                <div onClick={(e) => {
                    launchCreateScreenEventPlaylistPopup(data);

                    e.preventDefault();
                }} className="btn-plus-item">
                    <PlusCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(ScreenEventPlaylistModule);
